var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "9"
    }
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (3),
      expression: "3",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("\n            Какой тарифный план выбрать?\n        ")]), _vm._v(" "), _vm._l((_vm.tariffs), function(tariff) {
    return _c('div', {
      directives: [{
        name: "margin",
        rawName: "v-margin.bottom",
        value: (3),
        expression: "3",
        modifiers: {
          "bottom": true
        }
      }]
    }, [_c('div', [_c('v-text', {
      attrs: {
        "type": "title",
        "medium": ""
      }
    }, [_vm._v(_vm._s(tariff.title))])], 1), _vm._v(" "), _c('v-text', {
      domProps: {
        "innerHTML": _vm._s(tariff.description)
      }
    })], 1)
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa894e8e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariff/TariffsInfo.vue
// module id = 960
// module chunks = 0